import React from 'react';
import styled from 'styled-components';
import { fontFamily, fontSize } from '../../../../../../constants/text';
import { colors } from '../../../../../../constants/colors';
import { CallClinicButton } from './index';

const Root = styled.div.withConfig({ componentId: 'sc-gxjuxh-0' })`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: 30px auto 20px;
`;

const Header = styled.div.withConfig({ componentId: 'sc-gxjuxh-1' })`
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.medium};
  color: ${colors.squid};
  margin-bottom: 10px;
`;

const Subtext = styled.div.withConfig({ componentId: 'sc-gxjuxh-2' })`
  font-family: ${fontFamily.book};
  font-size: ${fontSize.default};
  color: ${colors.squid};
  margin: 10px 0 20px 0;
`;

type Props = {
  location: any;
  visible?: boolean;
};

const NoInPersonOnlineBookings = ({ location, visible }: Props) => {
  if (!visible) return null;

  return (
    <Root>
      <Header>Online bookings not available</Header>

      <Subtext>This clinic does not offer online booking for in-person visits.</Subtext>

      <CallClinicButton location={location} />
    </Root>
  );
};

export default NoInPersonOnlineBookings;
